import type { BreadcrumbProps } from './Breadcrumb.types'

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <nav className="p-4 bg-gray-100 rounded-md mb-6">
      <ol className="list-reset flex text-blue-600">
        {items?.map((item, index) => (
          <li key={index} className="inline-flex items-center">
            <a href={item.href} className="hover:underline">
              {item.label}
            </a>
            {index < items.length - 1 && <span className="mx-2">/</span>}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumb
